import React, { useEffect, useState } from "react";
import CommonBox from "./components/CommonBox";
// import slot_tab_img from './assets/images/game_card1.png'
import GifImagesSection from "./components/GifImagesSection";
import GameCard from "./components/GameCard";

const MiniGames = () => {
  const [miniGamesData, setMiniGamesData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMiniGamesData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/games/slot`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch slot data");
        }
        const data = await response.json();
        setMiniGamesData(data.lists);
      } catch (err) {
        console.error(err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchMiniGamesData();
  }, []);

  if (loading) return <p className="text-center">Loading mini games...</p>;
  if (error) return <p className="text-center text-red-500">Error: {error}</p>;

  return (
    <>
      <section className="slot-section">
        {/* <CommonBox heading="슬롯게임" englishHeading="slotgame" data={slotData} /> */}
        <CommonBox
          heading="미니게임"
          englishHeading="Mini Games"
          isEnglishHeadingOnMobile={false}
          isAuthenticated={true}
        >
          <div className="p-2.5">
            <ul className="grid grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-2.5 lg:gap-[15px] xl:gap-[15px] lg:p-2.5">
              {miniGamesData.map((item, index) => (
                <li
                  key={index}
                >
                  <GameCard
                    key={index}
                    game={item}
                  />
                </li>
              ))}
            </ul>
          </div>
        </CommonBox>
      </section>

      <section className="gif-section flex lg:hidden items-center justify-center">
        <GifImagesSection />
      </section>
    </>
  );
};

export default MiniGames;
